import { toast } from "react-toastify";

import { router } from "@/main";
import { startAppListening } from "@/store/utils";

import { useTermApi } from "./useTerm.api";

startAppListening({
  matcher: useTermApi.endpoints.getTermsUserByCompany.matchFulfilled,
  effect: ({ payload }) => {
    const companyId = sessionStorage.getItem("@App:temporaryCompanyId");
    const driverId = sessionStorage.getItem("@App:temporaryDriverId");

    if (companyId && driverId && payload?.content) {
      router.navigate({
        to: "/aprovar-termo/empresa/$companyId/$driverId",
        params: {
          companyId,
          driverId
        }
      });
    } else {
      router.navigate({ to: "/app" });
    }
  }
});

startAppListening({
  matcher: useTermApi.endpoints.saveTermsAuthorization.matchFulfilled,
  effect: () => {
    // toast.success("Login realizado com sucesso!");

    const driverStorageId = sessionStorage.getItem("@App:temporaryDriverId");
    sessionStorage.removeItem("@App:temporaryCompanyId");

    if (!driverStorageId) return;

    sessionStorage.removeItem("@App:temporaryDriverId");
    router.navigate({ to: "/app" });
  }
});

startAppListening({
  matcher: useTermApi.endpoints.saveTermsAuthorization.matchRejected,
  effect: ({ payload }) => {
    const err = payload as any;
    const errMessage = err?.response?.data?.message;

    if (err.response.data.code === "ER_DUP_ENTRY") toast.error(`Erro ao Cadastrar: ${errMessage}`);
  }
});
